import React, { Component } from 'react'
import moment from 'moment';
import { QRCodeSVG } from 'qrcode.react';
import { Datos_Empresa, FORMAT_NUMBER, points_Card, CURRENCY, Granel, Envasados } from "../../libs/utils/Const";
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";

const getUnitMsr = (docLine) => {
    const envasado = Envasados.includes(Number(docLine?.ItmsGrpCod));
    const glpGranel = Granel.includes(Number(docLine?.ItmsGrpCod));

    if (envasado || glpGranel) return docLine?.U_RS_UMED ?? '';
    return docLine?.SalUnitMsr ?? '';
}

const formatNumber = {
  separador: ',', // separador para los miles
  sepDecimal: '.', // separador para los decimales
  formatear: function (num) {
    num += '';
    let splitStr = num.split('.');
    let splitLeft = splitStr[0];
    let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
    let regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
    }
    return this.simbol + splitLeft + splitRight;
  },
  new: function (num, simbol) {
    this.simbol = simbol || '';
    if (typeof num == 'undefined') {
      num = 0;
    }
    if (isNaN(num)) {
      return num;
    }
    return this.formatear(Number(num).toFixed(2));
  },
};


class InvoiceDoc extends Component {

  RefreshDocModel = async (EditableDocModel) => {
    const { RefreshDocModel } = this.props;
    await RefreshDocModel(EditableDocModel);
    this.forceUpdate();
  }

  OnchangeBillStreet = async (value) => {
    const { EditableDocModel } = this.props;
    EditableDocModel.street = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeBillCounty = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.county = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeBillCity = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.city = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeBillBlock = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.block = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeRFC = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.rfc = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipStreet = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipStreet = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipCounty = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipCounty = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipCity = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipCity = value;
    this.RefreshDocModel(EditableDocModel)
  }

  OnchangeShipBlock = (value) => {
    const { EditableDocModel } = this.props
    EditableDocModel.shipBlock = value;
    this.RefreshDocModel(EditableDocModel)
  }

  EqualDataToNewDataModel = () => {
    const { EditableDocModel, BillAddress, ShipAddress, DocHeader } = this.props;
    EditableDocModel.street = BillAddress.Street ?? '';
    EditableDocModel.county = BillAddress.County ?? '';
    EditableDocModel.city = BillAddress.City ?? '';
    EditableDocModel.block = BillAddress.Block ?? '';
    EditableDocModel.zipCode = BillAddress.ZipCode ?? '';

    EditableDocModel.shipStreet = ShipAddress.Street ?? '';
    EditableDocModel.shipCounty = ShipAddress.County ?? '';
    EditableDocModel.shipCity = ShipAddress.City ?? '';
    EditableDocModel.shipBlock = ShipAddress.Block ?? '';
    EditableDocModel.shipZipCode = ShipAddress.ZipCode ?? '';

    EditableDocModel.rfc = DocHeader.LicTradNum ?? '';
    this.RefreshDocModel(EditableDocModel)
  }

  async componentDidUpdate(prevProps) {
    if (this.props.EditableMode !== prevProps.EditableMode) {
      await this.EqualDataToNewDataModel();
      return true;
    }
  }

  timeFormat = () => {
    const { DocHeader } = this.props;
    let timeFormat = '';
    if (DocHeader.CreateTS) {
      let time = (DocHeader.CreateTS || '').toString();
      if (time.length > 0) {
        let seconds = time.length - 2;
        let minutes = time.length - 4;
        timeFormat = time.slice(0, minutes) + ":" + time.slice(minutes, seconds) + ":" + time.slice(seconds, time.length)
      }
    }
    return timeFormat;
  }

  taxSystem = (key) => {
    let name = "";
    switch (key) {
      case "601":
        name = "General de Ley Personas Morales"
        break;

      case "603":
        name = "Personas Morales con Fines no Lucrativos"
        break;

      case "605":
        name = "Sueldos y Salarios e Ingresos Asimilados a Salarios"
        break;

      case "606":
        name = "Arrendamiento"
        break;

      case "607":
        name = "Régimen de Enajenación o Adquisición de Bienes"
        break;

      case "608":
        name = "Demás ingresos"
        break;

      case "610":
        name = "Residentes en el Extranjero sin Establecimiento Permanente en México"
        break;

      case "611":
        name = "Ingresos por Dividendos (socios y accionistas)"
        break;

      case "612":
        name = "Personas Físicas con Actividades Empresariales y Profesionales"
        break;

      case "614":
        name = "Ingresos por intereses"
        break;

      case "615":
        name = "Régimen de los ingresos por obtención de premios"
        break;

      case "616":
        name = "Sin obligaciones fiscales"
        break;

      case "620":
        name = "Sociedades Cooperativas de Producción que optan por diferir sus ingresos"
        break;

      case "621":
        name = "Incorporación Fiscal"
        break;

      case "622":
        name = "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras"
        break;

      case "623":
        name = "Opcional para Grupos de Sociedades"
        break;

      case "624":
        name = "Coordinados"
        break;

      case "625":
        name = "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas"
        break;

      case "626":
        name = "Régimen Simplificado de Confianza"
        break;

      default:
        break;
    }
    return name;
  }

  ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, countPages, folio, nextFolio) {
    return (
      <table><tr><td>
        <div className='mt-5' style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }}>
          <div className='text-right' style={{ fontSize: "14px" }}>
            <table>
              <tbody>
                <tr>
                  <td className='text-left'>
                    {folio}
                  </td>
                  <td className='text-right'>
                    {nextFolio + " - "}Pagina {countPages + 2}/{Math.trunc((DocLines.length - linesfirstPage) / linesfullPage) + 2}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className='row' style={{ paddingRight: "15px" }}>
            <table className='mt-2'>
              <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                <tr>
                  <th>Cant.</th>
                  <th>UMV</th>
                  <th>CVE</th>
                  <th>Cve P/S</th>
                  <th className="text-center">Código</th>
                  <th className="text-center">Descripción</th>
                  <th className="text-center">Tasa</th>
                  <th className="text-right">Precio U</th>
                  <th className="text-right">Importe</th>
                  {/* <th className="text-center">Descuento %</th> */}
                  <th className="text-right">Importe N.</th>
                </tr>
              </thead>
              <tbody style={{ border: "solid 1px" }}>
                {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                  DocLines.map((docLine) => {//51 es el limite de la primera pagina
                    if ((countLines2 > linesfirstPage + (linesfullPage * countPages)) && (countLines2 < linesfirstPage + (linesfullPage * (countPages + 1)))) {
                      countLines2++
                      return (
                        <tr style={{ fontSize: '12px' }}>
                          <td>{Number(docLine.Quantity).toFixed(2) ?? ''}</td>
                          <td>{getUnitMsr(docLine)}</td>
                          <td>{docLine.U_FMB_UM_SAT ?? ''}</td>
                          <td>{docLine.U_FMB_CLAVE_SAT ?? ''}</td>
                          <td className="text-center">{docLine.ItemCode ?? ''}</td>
                          <td className="text-center">{docLine.Dscription.substring(0, 35) ?? ''}</td>
                          <td className="text-center">{Number(docLine.VatPrcnt).toFixed(0) ?? ''}</td>
                          <td className="text-right">{formatNumber.new(docLine.Price) ?? ''}</td>
                          <td className="text-right">{formatNumber.new(docLine.Quantity * docLine.Price) ?? ''}</td>
                          {/* <td className="text-center">{Number(docLine.DiscPrcnt).toFixed(2) ?? 0}%</td> */}
                          <td className="text-right">{formatNumber.new(docLine.LineTotal ?? 0)}</td>
                        </tr>
                      );
                    } else {
                      countLines2++
                      return (<></>);
                    }
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
      </td></tr></table>
    );
  }

  AdvancePayments() {
    const { payments } = this.props
    let advancePayment = 0;
    if (!!payments) {
      for (let index = 0; index < payments.length; index++) {
        if (payments[index].typeMethod === "117" && payments[index].amount > 0) {
          advancePayment = advancePayment + Number(payments[index].amount);
        }
      }
    }
    return advancePayment
  }

  IsValidJSON = (entryString) => {
    try {
      JSON.parse(entryString);
      return true;
    } catch (error) {
      return false;
    }
  }
  round = (num) => {
    let m = Number((Math.abs(num) * 100).toPrecision(15));
    return Math.round(m) / 100 * Math.sign(num);
  }
  refreshTotal = (header, Items) => {
    let subTotal = 0;
    let subtotalDpm = 0;
    let impuestos = 0;
    let discount = 0;
    let total = 0;
    Items.map(item => {
      let impuesto = this.round(parseFloat(item.LineTotal).toFixed(2) * (item.VatPrcnt / 100));
      item.TaxeResult = Number(Number(impuesto)).toFixed(2);

      subTotal += Number(item.LineTotal);
      impuestos += parseFloat(Number(item.TaxeResult).toFixed(2));
    });
    let iva = (impuestos * 100) / subTotal;
    subtotalDpm = subTotal - header.DpmAmnt;
    discount = subtotalDpm * (header.DiscPrcnt / 100);
    impuestos = subtotalDpm * (iva / 100);
    total = parseFloat(parseFloat(subtotalDpm).toFixed(2) - parseFloat(discount).toFixed(2)) + parseFloat(parseFloat(impuestos).toFixed(2));
    let totals = {
      Subtotal: parseFloat(Number(header.DocTotal) - Number(header.VatSum)).toFixed(2),
      Discount: parseFloat(discount).toFixed(2),
      Taxes: parseFloat(header.VatSum).toFixed(2),
      Total: parseFloat(header.DocTotal).toFixed(2),
    }
    return totals;
  };


  getRegimenFiscal = (regimen) => {
    let descripcion = "";

    switch (regimen) {
      case '601':
        descripcion = "General de Ley Personas Morales";
        break;
      case '603':
        descripcion = "Personas Morales con Fines no Lucrativos";
        break;
      case '605':
        descripcion = "Sueldos y Salarios e Ingresos Asimilados a Salarios";
        break;
      case '606':
        descripcion = "Arrendamiento";
        break;
      case '607':
        descripcion = "Régimen de Enajenación o Adquisición de Bienes";
        break;
      case '608':
        descripcion = "Demás ingresos";
        break;
      case '610':
        descripcion = "Residentes en el Extranjero sin Establecimiento Permanente en México";
        break;
      case '611':
        descripcion = "Ingresos por Dividendos (socios y accionistas)";
        break;
      case '612':
        descripcion = "Personas Físicas con Actividades Empresariales y Profesionales";
        break;
      case '614':
        descripcion = "Ingresos por intereses";
        break;
      case '615':
        descripcion = "Régimen de los ingresos por obtención de premios";
        break;
      case '616':
        descripcion = "Sin obligaciones fiscales";
        break;
      case '620':
        descripcion = "Sociedades Cooperativas de Producción que optan por diferir sus ingresos";
        break;
      case '621':
        descripcion = "Incorporación Fiscal";
        break;
      case '622':
        descripcion = "Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras";
        break;
      case '623':
        descripcion = "Opcional para Grupos de Sociedades";
        break;
      case '624':
        descripcion = "Coordinados";
        break;
      case '625':
        descripcion = "Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas";
        break;
      case '626':
        descripcion = "Régimen Simplificado de Confianza";
        break;
      default:
        descripcion = "";
    }

    return descripcion;
  };

  getUsoCFDI = (UsoCFDI) => {
    let descripcion = "";

    switch (UsoCFDI) {
      case 'G01':
        descripcion = "Adquisición de mercancías";
        break;
      case 'G02':
        descripcion = "Devoluciones, descuentos o bonificaciones";
        break;
      case 'G03':
        descripcion = "Gastos en general";
        break;
      case 'I01':
        descripcion = "Construcciones";
        break;
      case 'I02':
        descripcion = "Mobiliario y equipo de oficina por inversiones";
        break;
      case 'I03':
        descripcion = "Equipo de transporte";
        break;
      case 'I04':
        descripcion = "Equipo de computo y accesorios";
        break;
      case 'I05':
        descripcion = "Dados, troqueles, moldes, matrices y herramental";
        break;
      case 'I06':
        descripcion = "Comunicaciones telefónicas";
        break;
      case 'I07':
        descripcion = "Comunicaciones satelitales";
        break;
      case 'I08':
        descripcion = "Otra maquinaria y equipo";
        break;
      case 'D01':
        descripcion = "Honorarios médicos, dentales y gastos hospitalarios";
        break;
      case 'D02':
        descripcion = "Gastos médicos por incapacidad o discapacidad";
        break;
      case 'D03':
        descripcion = "Gastos funerales";
        break;
      case 'D04':
        descripcion = "Donativos";
        break;
      case 'D05':
        descripcion = "Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)";
        break;
      case 'D06':
        descripcion = "Aportaciones voluntarias al SAR";
        break;
      case 'D07':
        descripcion = "Primas por seguros de gastos médicos";
        break;
      case 'D08':
        descripcion = "Gastos de transportación escolar obligatoria";
        break;
      case 'D09':
        descripcion = "Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones";
        break;
      case 'D10':
        descripcion = "Pagos por servicios educativos (colegiaturas)";
        break;
      case 'S01':
        descripcion = "Sin efectos fiscales";
        break;
      case 'CP01':
        descripcion = "Pagos";
        break;
      case 'CN01':
        descripcion = "Nómina";
        break;
      default:
        descripcion = "";
    }

    return descripcion;
  };

  getTipoDeComprobante = (TipoDeComprobante) => {
    let descripcion = "";

    switch (TipoDeComprobante) {
      case 'I':
        descripcion = "Ingreso";
        break;
      case 'E':
        descripcion = "Egreso";
        break;
      case 'T':
        descripcion = "Traslado";
        break;
      case 'N':
        descripcion = "Nómina";
        break;
      case 'P':
        descripcion = "Pago";
        break;
      default:
        descripcion = "";
    }

    return descripcion;
  };

  getFormaPago = (FormaPago) => {
    let descripcion = "";

    switch (FormaPago) {
      case '01':
        descripcion = "Efectivo";
        break;
      case '02':
        descripcion = "Cheque nominativo";
        break;
      case '03':
        descripcion = "Transferencia electrónica de fondos";
        break;
      case '04':
        descripcion = "Tarjeta de crédito";
        break;
      case '05':
        descripcion = "Monedero electrónico";
        break;
      case '06':
        descripcion = "Dinero electrónico";
        break;
      case '08':
        descripcion = "Vales de despensa";
        break;
      case '12':
        descripcion = "Dación en pago";
        break;
      case '13':
        descripcion = "Pago por subrogación";
        break;
      case '14':
        descripcion = "Pago por consignación";
        break;
      case '15':
        descripcion = "Condonación";
        break;
      case '17':
        descripcion = "Compensación";
        break;
      case '23':
        descripcion = "Novación";
        break;
      case '24':
        descripcion = "Confusión";
        break;
      case '25':
        descripcion = "Remisión de deuda";
        break;
      case '26':
        descripcion = "Prescripción o caducidad";
        break;
      case '27':
        descripcion = "A satisfacción del acreedor";
        break;
      case '28':
        descripcion = "Tarjeta de débito";
        break;
      case '29':
        descripcion = "Tarjeta de servicios";
        break;
      case '30':
        descripcion = "Aplicación de anticipos";
        break;
      case '31':
        descripcion = "Intermediario pagos";
        break;
      case '99':
        descripcion = "Por definir";
        break;
      default:
        descripcion = "";
    }

    return descripcion;
  };

  getMetodoPago = (MetodoPago) => {
    let descripcion = "";

    switch (MetodoPago) {
      case 'PUE':
        descripcion = "Pago en una sola exhibición";
        break;
      case 'PPD':
        descripcion = "Pago en parcialidades o diferido";
        break;
      default:
        descripcion = "";
    }

    return descripcion;
  };

  render() {
    const { EditableMode, DocLines, DocHeader, EditableDocModel, BillAddress, ShipAddress, EditParam1, user, InfoByFolio, tckfolio, reprint, time, title, PuntosGenerados, PointsCardModel, prioridadVta } = this.props;
    let linesForAllInOne = 7;
    let linesfirstPage = 45;
    let linesfullPage = 68;
    const order = this.refreshTotal(DocHeader, DocLines);

    let remainingLines = (DocLines.length - linesfirstPage) - (linesfullPage * Math.trunc((DocLines.length - linesfirstPage) / linesfullPage));
    let totalPages = Math.ceil((DocLines.length - linesfirstPage) / linesfullPage);

    let countLines = 1;
    let countLines2 = 1;

    let extraTables = [];
    const advancePayment = Number(this.AdvancePayments());

    for (let index = 0; index < totalPages; index++) {
      extraTables.push(this.ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, index, InfoByFolio.folio, (!!InfoByFolio.nextFolio ? InfoByFolio.nextFolio : "")))
    }

    let XML = {};
    // let xml = DocHeader.U_FMB_XMLTIMBRA ? DocHeader.U_FMB_XMLTIMBRA.includes('UUID') ? JSON.parse(DocHeader.U_FMB_XMLTIMBRA) : null : null;

    let xml = (DocHeader.U_FMB_XMLTIMBRA && DocHeader.U_FMB_XMLTIMBRA.includes('UUID')) ? (this.IsValidJSON(DocHeader.U_FMB_XMLTIMBRA) ? JSON.parse(DocHeader.U_FMB_XMLTIMBRA) : null) : null;

    XML = {
      isTimbra: xml ? true : false,
      info: xml
    }

    let cadenaQR = '';
    let cfdiCaComplemento = '';
    let totalLetra = '';
    let docType = '';
    if (xml) {
      cadenaQR = `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?&id=` +
        xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID + `&re=` +
        xml.cfdiEmisor._attributes.Rfc + `&rr=` +
        xml.cfdiReceptor._attributes.Rfc + `&tt=` +
        xml._attributes.Total + `&fe=` +
        xml._attributes.Sello.substring(xml._attributes.Sello.length - 8, xml._attributes.Sello.length);

      cfdiCaComplemento =
        "|" +
        "|" +
        xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.Version +
        "|" +
        xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID +
        "|" +
        xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.FechaTimbrado +
        "|" +
        xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.RfcProvCertif +
        "|" +
        "|" +
        xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloCFD +
        "|" +
        xml.cfdiComplemento.tfdTimbreFiscalDigital._attributes.NoCertificadoSAT +
        "|" +
        "|";
      let numeroLetra = new NumeroLetra();
      totalLetra = numeroLetra.NumeroALetras("MX", Number(Number(DocHeader.DocTotal).toFixed(2)));
      docType = Number(DocHeader.ObjType) === 14 ? 'Nota de Crédito' : DocHeader ? DocHeader.isIns === 'Y' ? 'Fac.Reserva' : XML.info._attributes.MetodoPago === 'PPD' || DocHeader.U_FMB_METODO_PAGO === 'PPD' ? (XML.info._attributes.MetodoPago || 'Fac.Crédito') : InfoByFolio.isDeliveryInvoice === 'Y' ? 'COD' : 'Fac.Directa' : InfoByFolio.isDeliveryInvoice === 'Y' ? 'Fac.Directa  COD' : 'Fac.Directa';
    } else {
      docType = Number(DocHeader.ObjType) === 14 ? 'Nota de Crédito' : DocHeader ? DocHeader.isIns === 'Y' ? 'Fac.Reserva' : InfoByFolio.isDeliveryInvoice === 'Y' ? 'COD' : 'Fac.Directa' : InfoByFolio.isDeliveryInvoice === 'Y' ? 'Fac.Directa  COD' : 'Fac.Directa';
    }
    let nota = ''
    if (title === 'Factura a domicilio' && InfoByFolio?.paidOut !== "Y") {
      nota = ' (La forma de pago aparecerá cuando el documento este pagado y timbrado)';
      DocHeader.U_FMB_FORMA_PAGO = '--';
      DocHeader.U_FMB_METODO_PAGO = 'PUE';
    }
    let baseDocument = '';
    if (DocHeader.ByRInvoice && DocHeader.ByRInvoice === 'Y') { baseDocument = ' de reserva' }

    let timbraDate = '';
    if (XML.isTimbra) {
      const date = new Date(XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.FechaTimbrado);
      timbraDate = `${date.getDate()} de ${date.toLocaleString('es-ES', { month: 'long' }).toLowerCase()} de ${date.getFullYear()}`;
    }
    //#region CFDI Relacionados
    let titlecfdiRelacionados = '';
    let UUIDSustitutoTipo = '';
    let filas = [];
    if (XML.isTimbra && XML.info.cfdiRelacionados) {
      UUIDSustitutoTipo = XML.info.cfdiRelacionados._attributes.TipoRelacion;

      let cfdiRelacionados = XML.info.cfdiRelacionados.cfdiRelacionado;

      if (cfdiRelacionados.length > 0) {
        for (let index = 0; index < cfdiRelacionados.length; index++) {
          const uuid = cfdiRelacionados[index];
          filas.push(` - ${uuid._attributes.UUID} -`);
        }
      } else {
        filas.push(` - ${cfdiRelacionados._attributes.UUID} -`);
      }
      if (UUIDSustitutoTipo == '04') {
        titlecfdiRelacionados = 'Documentos en Sustitución'
      } else if (UUIDSustitutoTipo == '01') {
        titlecfdiRelacionados = 'Documentos Relacionados'
      }
    }
    //#endregion CFDI Relacionados

    return (
      <>
        {/* Facturas con 10 o menos articulos */}
        {DocLines.length <= linesForAllInOne &&
          <table><tr><td>
            <div id="printInvoice" >
              <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }}>
                {DocLines.length <= linesForAllInOne &&
                  <div className='text-right' style={{ fontSize: "14px" }}>
                    <table>
                      <tbody>
                        <tr>
                          {InfoByFolio?.paidOut !== "Y" && (
                            <td className='text-right text-weight-bold'>
                              Prioridad de entrega: {prioridadVta(DocHeader?.U_FMB_PRIORIDADVTA)}
                            </td>
                          )}
                          <td className='text-right'>
                            {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                }
                {DocLines.length > linesForAllInOne && DocLines.length < 71 ?
                  <div className='text-right' style={{ fontSize: "14px" }}>{(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina 1/2</div>
                  :
                  (DocLines.length > 71) && <div className='text-right' style={{ fontSize: "14px" }}>{(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina 1/3</div>
                }
                <div className="row">
                  <div className="col-3">
                    <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                    <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />
                      {/* <span className="text-center">{user.Timbra.RFC || ''}</span><br /> */}
                      <strong>{Datos_Empresa.RFC}</strong></p>

                    {/* <span className="text-left">Teléfono(s): {user.Branch.Phone || ''}</span> */}
                    <p style={{ fontSize: '10px' }}> <strong>Régimen Fiscal: </strong> 601 - General de Ley Personas Morales <br />{user.Branch.Address}.<br />
                      <span className="text-left">Teléfono(s): {user.Branch.Phone}</span></p>
                    {/* <p className="text-center"><br/>{user.Branch.Address || ''}</p> */}
                    <p className="text-center"></p>

                  </div>
                  <div className="col-9" style={{ fontSize: "13px" }}>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">Serie</th>
                          <th className="text-center">Folio</th>
                          <th className="text-center">Número de Certificado</th>
                          <th className="text-center">Fecha Emisión</th>
                          <th className="text-center">Lugar de Expedición</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center">{XML.isTimbra ? XML.info._attributes.Serie : ''}</td>
                          <td className="text-center">{!!DocHeader.DocNum && DocHeader.DocNum}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info._attributes.NoCertificado : ''}</td>
                          <td className="text-center">{`${XML.isTimbra ? XML.info._attributes.Fecha : ''}`}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info._attributes.LugarExpedicion : ''}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">Folio Fiscal</th>
                          <th className="text-center">Certificado SAT</th>
                          <th className="text-center">Fecha y Hora de Certificación</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center" style={{ fontsize: "2.5vw" }}>{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID : ''}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.NoCertificadoSAT : ''}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.FechaTimbrado : ''}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">Cliente</th>
                          <th className="text-center">Nombre del Cliente</th>
                          <th className="text-center">Régimen Fiscal</th>
                          <th className="text-center">Uso CFDI</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center">{DocHeader.CardCode || ""}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.Nombre : (DocHeader.CardName || "")}</td>
                          <td className="text-center">{DocHeader.U_FMB_REGIMEN_FISCAL ? `${DocHeader.U_FMB_REGIMEN_FISCAL} - ${this.getRegimenFiscal(DocHeader.U_FMB_REGIMEN_FISCAL)}` : ""}</td>
                          <td className="text-center">{XML.isTimbra ? `${XML.info.cfdiReceptor._attributes.UsoCFDI} - ${this.getUsoCFDI(XML.info.cfdiReceptor._attributes.UsoCFDI)}` : ""}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th className="text-center">Tipo Documento</th>
                          <th className="text-center">Condiciones de Pago</th>
                          <th className="text-center">R.F.C.</th>
                          <th className="text-center">Moneda</th>
                          <th className="text-center">Folio</th>
                          <th className="text-center">N° Referencia</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-center">{docType}</td>
                          <td className="text-center">{DocHeader.GroupName || ""}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.Rfc : !!DocHeader.LicTradNum && DocHeader.LicTradNum}</td>
                          <td className="text-center">{XML.isTimbra ? XML.info._attributes.Moneda : !!DocHeader.DocCur && DocHeader.DocCur}</td>
                          <td className="text-center">{InfoByFolio.folio || ''}</td>
                          <td className="text-center"><strong>{DocHeader.NumAtCard || ''}</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='row' style={{ paddingRight: "15px" }}>
                  {reprint &&
                    <div className='col-4'>
                      <label className="text-center" style={{ fontSize: "14px" }}>{<><strong>REIMPRESIÓN: </strong>{user.U_NAME} {time}</>}</label>
                    </div>
                  }
                  <div className={reprint ? 'col-4' : 'col-12'}>
                    <div className="text-center" style={{ fontSize: "14px", fontWeight: "bold" }}>
                      {title + nota + (InfoByFolio && InfoByFolio.paidOut && InfoByFolio.paidOut == "Y" ? " (pagada)" : "")}
                      {(DocHeader.U_FMB_RelatedFolio && docType === 'Nota de Crédito') ? <> <br /> {`Basada en la factura${baseDocument}: ${DocHeader.U_FMB_RelatedFolio}`} </> : ''}
                    </div>
                  </div>
                </div>
                <div className='row' style={{ paddingRight: "15px", fontSize: "13px" }}>
                  <table className="text-center">
                    <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                      <th>DOMICILIO DE FACTURACIÓN</th>
                      <th colSpan={2}>Forma y método de pago</th>
                    </tr>
                    <tr>
                      <td style={{ border: "solid 1px" }}>
                        {(XML.isTimbra && DocHeader.BillAddress) ? `${DocHeader.BillAddress.Street ? DocHeader.BillAddress.Street + ', ' : ''}${DocHeader.BillAddress.Block ? DocHeader.BillAddress.Block + ', ' : ''}${DocHeader.BillAddress.City ? DocHeader.BillAddress.City + ', ' : ''}${DocHeader.BillAddress.State ? DocHeader.BillAddress.State + ', ' : ''}${DocHeader.BillAddress.Country ? DocHeader.BillAddress.Country + ', ' : ''} C.P ${DocHeader.BillAddress.ZipCode ?? ''}`
                          : `${DocHeader.BillDirection || ""}`
                        }
                      </td>
                      <td style={{ border: "solid 1px" }}>{XML.isTimbra ? `${XML.info._attributes.FormaPago} - ${this.getFormaPago(XML.info._attributes.FormaPago)}` : `${DocHeader.U_FMB_FORMA_PAGO} - ${this.getFormaPago(DocHeader.U_FMB_FORMA_PAGO)}`}</td>
                      <td style={{ border: "solid 1px" }}>{XML.isTimbra ? `${XML.info._attributes.MetodoPago} - ${this.getMetodoPago(XML.info._attributes.MetodoPago)}` : `${DocHeader.U_FMB_METODO_PAGO} - ${this.getMetodoPago(DocHeader.U_FMB_METODO_PAGO)}`}</td>
                    </tr>
                    <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                      <th>DOMICILIO DE ENTREGA</th>
                      <th colSpan={2}>Fecha de vencimiento</th>
                    </tr>
                    <tr>
                      <td rowSpan={3} style={{ border: "solid 1px" }}>
                        {(XML.isTimbra && ShipAddress) ? `${ShipAddress.Street ? ShipAddress.Street + ', ' : ''}${ShipAddress.Block ? ShipAddress.Block + ', ' : ''}${ShipAddress.City ? ShipAddress.City + ', ' : ''}${ShipAddress.State ? ShipAddress.State + ', ' : ''}${ShipAddress.Country ? ShipAddress.Country + ', ' : ''} C.P ${ShipAddress.ZipCode ?? ''}`
                          : `${DocHeader.ShipDirection ?? 'NO APLICA'}`
                        }
                      </td>
                      <td colSpan={2} style={{ border: "solid 1px" }}>{!!DocHeader.DocDueDate && moment(DocHeader.DocDueDate).format("DD/MM/YYYY")}</td>
                    </tr>
                    <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                      <th>Nombre del capturista</th>
                      <th>Asesor de ventas</th>
                    </tr>
                    <tr>
                      <td style={{ border: "solid 1px" }}>{DocHeader.U_FMB_User || ''}</td>
                      <td style={{ border: "solid 1px" }}>{DocHeader.SlpName || ''} </td>
                    </tr>
                  </table>
                  <table className='mt-2'>
                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                      <tr>
                        <th>Cant.</th>
                        <th>UMV</th>
                        <th>CVE</th>
                        <th>Cve P/S</th>
                        <th className="text-center">Código</th>
                        <th className="text-center">Descripción</th>
                        <th className="text-center">Tasa</th>
                        <th className="text-right">Precio U</th>
                        <th className="text-right">Importe</th>
                        {/* <th className="text-center">Descuento %</th> */}
                        <th className="text-right">Importe N.</th>
                        {PointsCardModel && points_Card && <th className="text-right">Aplica Monedero</th>}
                      </tr>
                    </thead>
                    <tbody style={{ border: "solid 1px" }}>
                      {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                        DocLines.map((docLine) => {//51 es el limite de la primera pagina
                          if (countLines < 52) {
                            countLines++
                            return (
                              <>
                                <tr style={{ fontSize: '12px' }}>
                                  <td>{Number(docLine.Quantity).toFixed(2) ?? ''}</td>
                                  <td>{getUnitMsr(docLine)}</td>
                                  <td>{docLine.U_FMB_UM_SAT ?? ''}</td>
                                  <td>{docLine.U_FMB_CLAVE_SAT ?? ''}</td>
                                  <td className="text-center">{docLine.ItemCode ?? ''}</td>
                                  <td className="text-center">{docLine.Dscription.substring(0, 35) ?? ''}</td>
                                  <td className="text-center">{Number(docLine.VatPrcnt).toFixed(0) ?? ''}</td>
                                  <td className="text-right">{formatNumber.new(docLine.Price) ?? ''}</td>
                                  <td className="text-right">{formatNumber.new(docLine.Quantity * docLine.Price) ?? ''}</td>
                                  {/* <td className="text-center">{Number(docLine.DiscPrcnt).toFixed(2) ?? 0}%</td> */}
                                  <td className="text-right">{formatNumber.new(docLine.LineTotal ?? 0)}</td>
                                  {PointsCardModel && points_Card && <td className="text-center input-cantidad">{docLine.U_FMB_AplicaMonedero === 'Y' ? 'SI' : 'NO'}</td>}
                                </tr>
                                {docLine.U_FMB_LineComment !== "" ?
                                  <tr style={{ fontSize: '12px' }}>
                                    <td ></td>
                                    <td colSpan={9}><strong>Comentario: </strong>{docLine.U_FMB_LineComment}</td>
                                  </tr>
                                  : ""
                                }
                              </>
                            );
                          } else {
                            return ("");
                          }
                        })
                      }
                    </tbody>
                  </table>
                  {XML.isTimbra && XML.info.cfdiRelacionados ?
                    <>
                      <table className='mt-2'>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                          <tr>
                            <th className="text-center" colSpan={4}>{titlecfdiRelacionados}</th>
                          </tr>
                        </thead>
                        <tbody style={{ border: "solid 1px" }}>
                          <tr style={{ fontSize: '9px' }}>
                            <td className="text-center"><strong>Tipo Relación: </strong></td>
                            <td className="text-center">{UUIDSustitutoTipo}</td>
                            <td className="text-center"><strong>UUID: </strong></td>
                            <td className="text-center">
                              {filas.map((uuid, i) => (
                                <div key={i}> {uuid} </div>
                              ))}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                    : <></>
                  }
                </div>
                {/* <div className='row' style={{ paddingRight: "15px" }}>
                  <table className='mt-2'>
                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                      <tr>
                        <th>Cant.</th>
                        <th>UMV</th>
                        <th>CVE</th>
                        <th>Cve P/S</th>
                        <th className="text-center">Código</th>
                        <th className="text-center">Descripción</th>
                        <th className="text-right">Tasa</th>
                        <th className="text-right">Precio U</th>
                        <th className="text-right">Importe</th>
                        <th className="text-right">Descuento %</th>
                        <th className="text-right">Importe N.</th>
                      </tr>
                    </thead>
                    <tbody style={{ border: "solid 1px" }}>
                      {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                        DocLines.map((docLine) => {//51 es el limite de la primera pagina
                          if (countLines2 >= 51 && countLines2 < 120) {
                            countLines2++
                            return (
                              <tr style={{ fontSize: '12px' }}>
                                <td>{docLine.Quantity ?? ''}</td>
                                <td>{docLine.SalUnitMsr ?? ''}</td>
                                  <td>{docLine.U_FMB_UM_SAT ?? ''}</td>
                                  <td>{docLine.U_FMB_CLAVE_SAT ?? ''}</td>
                                <td className="text-center">{docLine.ItemCode ?? ''}</td>
                                <td className="text-center">{docLine.Dscription.substring(0, 35) ?? ''}</td>
                                <td className="text-center">{docLine.VatPrcnt ?? ''}</td>
                                <td className="text-right">{formatNumber.new(docLine.Price) ?? ''}</td>
                                <td className="text-center">{formatNumber.new(docLine.Quantity * docLine.Price) ?? ''}</td>
                                <td className="text-center">{docLine.DiscPrcnt ?? 0}%</td>
                                <td className="text-right">{formatNumber.new(docLine.LineTotal ?? 0)}</td>
                              </tr>
                            );
                          }else{
                            countLines2++
                            return(<></>);
                          }
                        })
                      }
                    </tbody>
                  </table>
                </div> */}
                <div className='row mt-2'>
                  <div className='col-8'>
                    <p style={DocHeader.isIns === 'Y' ? { marginLeft: "-13px", fontSize: '8px' } : (tckfolio || "") !== "" ? { marginLeft: "-13px", fontSize: '10px' } : { marginLeft: "-13px", fontSize: '12px' }}>
                      Comentarios: {DocHeader.Comments || ""}<br />
                      {(tckfolio || "") !== "" ? <div style={{ color: "red" }}>FACTURACION DE TICKET. MERCANCIA PREVIAMENTE ENTREGADA CON ESTE FOLIO: {tckfolio} </div> : ""}
                      {DocHeader.isIns === 'Y' ? <strong> ESTE MATERIAL DEBERA SER RETIRADO O RECIBIDO POR EL CLIENTE EN UN LAPSO MAXIMO DE 60 DIAS, DESPUES DE ESTE PERIODO SE LE APLICARA UN CARGO DE 10% MENSUAL POR ALMACENAMIENTO DE MATERIAL PENDIENTE DE ENTREGA.<br /></strong> : ""}
                      <span style={{ textDecoration: "underline" }}>TODA DEVOLUCIÓN CAUSARÁ UN CARGO DEL 10% DEL TOTAL DE LA FACTURA POR GASTOS ADMINISTRATIVOS.</span><br />
                      <span style={{ fontStyle: "italic" }}>NO ACEPTAMOS DEVOLUCIONES NI CANCELACIONES DESPUÉS DE 7 DÍAS, SIN EXCEPCIONES. EN MATERIALES ESPECIALES NO HAY DEVOLUCIONES.</span><br />
                      EFECTOS FISCALES AL PAGO. ESTA FACTURA SERÁ PAGADA EN UNA SOLA EXHIBICIÓN. <br />
                      Régimen fiscal del receptor: {this.taxSystem(!!DocHeader.U_FMB_REGIMEN_FISCAL ? DocHeader.U_FMB_REGIMEN_FISCAL : "")}.<br />
                      {totalLetra} {XML.isTimbra ? XML.info._attributes.Moneda : ''}
                    </p>
                    {/* {DocHeader.Comments && <p style={{ marginLeft: "-13px", fontSize: '12px' }}>
                      Comentarios del documento:<br />
                      {DocHeader.Comments}<br />
                    </p>} */}
                  </div>
                  <div className='col-4'>
                    <table>
                      <tbody style={{ fontSize: '12px' }}>
                        <tr>
                          <td className='text-right'><strong>Subtotal: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderTop: "solid 1px", minWidth: "6.25vw" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(order.Subtotal) ?? ''}</td>
                        </tr>
                        {/* <tr>
                          <td className='text-right'><strong>Descuento: %</strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{formatNumber.new(DocHeader.DiscPrcnt) ?? 0}</td>
                        </tr> */}
                        <tr>
                          <td className='text-right'><strong>IGV: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(order.Taxes) ?? ''}</td>
                        </tr>
                        {/* <tr>
                          <td className='text-right'><strong>Retención: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{''}</td>
                        </tr> */}
                        <tr>
                          <td className='text-right'><strong>Total: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderBottom: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(order.Total) ?? ''}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {PuntosGenerados.length > 0 ?
                    <>
                      <div className='col-4'>
                      </div>
                      <div className='col-4 text-center'>
                        <p style={{ marginBottom: '0px' }}>
                          <><strong>¡</strong>Esta compra te ha generado <strong> {PuntosGenerados[0].points_earned} Puntos!</strong></>
                        </p>
                      </div>
                      <div className='col-4'>
                      </div>
                    </>
                    :
                    ''
                  }
                  {PointsCardModel && PointsCardModel.Customer && PointsCardModel.Customer.LostPoints && Object.keys(PointsCardModel.Customer.LostPoints).length !== 0 && (Object.keys(PointsCardModel.Customer.LostPoints).length !== 0 && PointsCardModel.Customer.LostPoints.puntos !== 0) ?
                    <>
                      <div className='col-4'>
                      </div>
                      <div className='col-4 text-center'>
                        <p style={{ marginBottom: '0px' }}>
                          <><strong>!Te perdiste de {PointsCardModel.Customer.LostPoints.puntos} Puntos!</strong></>
                        </p>
                      </div>
                      <div className='col-4'>
                      </div>

                      <div className='col-12 text-center'>
                        <p style={{ marginBottom: '0px' }}>
                          Este documento podría haberte sumado puntos en nuestro monedero electrónico. ¡Únete ahora y no dejes pasar más recompensas!
                        </p>
                      </div>
                    </>
                    :
                    ''
                  }
                </div>
                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                  <div className='col-12' style={{ border: "solid 1px" }}>
                    <table>
                      <thead>
                        <tr>
                          <th className="text-center"></th>
                          <th className="text-center">Este documento es una impresión de un comprobante fiscal digital</th>
                          <th className="text-center">Este documento es una representación impresa de un CFDI</th>
                          <th className="text-center"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-left" colSpan={3}>
                            <strong>Sello digital autorizado:</strong><br />
                            <p class='digitalStamp' style={{ marginBottom: "-5px" }}>{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloCFD : ''}</p>
                          </td>
                          <td className="text-center" rowSpan={2}>
                            <QRCodeSVG
                              value={cadenaQR}
                              height={92}
                              width={92}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="text-left" colSpan={3}><strong>Sello digital SAT:</strong>
                            <p className='digitalStamp' style={{ marginBottom: "-5px" }}>
                              {XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloSAT : ''}
                            </p>
                          </td>

                        </tr>
                        <tr>
                          <td className="text-left" colSpan={4}>
                            <strong>Cadena original:</strong>
                            <p className='digitalStampAlt' style={{ marginBottom: "5px" }}>{cfdiCaComplemento}</p>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                  <div className='col-12' style={{ border: "solid 1px" }}>
                    <p style={{ fontSize: '11px' }}>
                      {`Pagaré No.1 En ${DocHeader.U_FMB_LUGAREXPEDICION || ''}, a ${timbraDate}. Bueno por ${CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal) ?? ''}`} <br />
                      {`Debo(emos) y pagaré(mos) incondicionalmente por este pagaré a la orden de ${Datos_Empresa.Nombre} ${Datos_Empresa.Sociedad},`}<br />
                      {`Fecha pago: ${`${!!DocHeader.DocDate && moment(DocHeader.DocDate).format("DD/MM/YYYY")}`}.`}<br />
                    </p>
                    <p style={{ fontSize: '11px' }}>
                      {`La cantidad de: ${totalLetra} ${XML.isTimbra ? XML.info._attributes.Moneda : ''}
                      Valor recibido a mi(nuestra) entera satisfacción, este pagaré sujeto a la condición de que al no pagarse a su vencimiento será exigible, desde la fecha de su vencimiento de este
                      documento hasta el día de su liquidación, causará intereses moratorios al tipo de 3% mensual, pagadero en esta ciudad justamente con el principal.`}
                    </p>
                    <table>
                      <thead>
                        <tr>
                          <th className="text-center"></th>
                          <th className="text-left"><strong>Nombre y datos del deudor</strong></th>
                          <th className="text-center">Aceptamos</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-right">Nombre:</td>
                          <td className="text-left">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.Nombre : !!DocHeader.CardName && DocHeader.CardName}</td>
                          <td className="text-center"></td>
                        </tr>
                        <tr>
                          <td className="text-right">RUT:</td>
                          <td className="text-left">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.Rfc : !!DocHeader.LicTradNum && DocHeader.LicTradNum}</td>
                          <td className="text-center">______________________________</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td className="text-left"></td>
                          <td className="text-center">Firma</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <tbody>
                        <tr>
                          <td className="text-center">Dirección:
                            {(XML.isTimbra && DocHeader.BillAddress) ?
                              (`${DocHeader.BillAddress.Street ? DocHeader.BillAddress.Street + ', ' : ''}${DocHeader.BillAddress.Block ? DocHeader.BillAddress.Block + ', ' : ''}${DocHeader.BillAddress.City ? DocHeader.BillAddress.City + ', ' : ''}${DocHeader.BillAddress.State ? DocHeader.BillAddress.State + ', ' : ''}${DocHeader.BillAddress.Country ? DocHeader.BillAddress.Country + ', ' : ''} C.P ${DocHeader.BillAddress.ZipCode ?? ''}`)
                              :
                              (`${DocHeader.BillDirection}`)
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className='row mt-5' style={{ paddingRight: "15px" }}>
                  <div className='col-2' style={{ border: "solid 1px" }}>
                    <p className='text-center m-4' style={{ margin: "auto" }}>
                      <strong>REFERENCIAS<br />PARA<br />DEPÓSITO<br />BANCARIO</strong>
                    </p>
                  </div>
                  <div className='col-10 p-2' style={{ border: "solid 1px" }}>
                    <table>
                      <tbody>
                        <tr>
                          <td>Para transferencias:</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Para transferencias:</td>
                          <td>Cuenta: 00000515541</td>
                          <td>CLABE: 113180000005155411</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Para depósitos en ventanilla:</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Banco: Santander</td>
                          <td>Cuenta: 65506444181</td>
                          <td>CLABE: 014730655064441811</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Banco: HSBC</td>
                          <td>Cuenta: 4062752217</td>
                          <td>CLABE: 021730040627522173</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </td></tr></table>
        }

        {/* Facturas con mas de 10*/}
        {DocLines.length > linesForAllInOne &&
          <>

            {/* Primera hoja de la factura */}
            <table><tr><td>
              <div id="printInvoice" >
                <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }}>
                  <div className="row" style={{ fontSize: "14px" }}>
                    <div className="col-md-3 col-lg-3"></div>
                    {InfoByFolio?.paidOut !== "Y" && (
                      <div className="col-md-3 col-lg-3">
                        Prioridad de entrega: {prioridadVta(DocHeader?.U_FMB_PRIORIDADVTA)}
                      </div>
                    )}
                    <div className="col-md-3 col-lg-3"></div>
                    <div className="col-md-3 col-lg-3 text-right">
                      {DocLines.length > linesForAllInOne && DocLines.length < 71 ? (
                        (!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - Página 1/2"
                      ) : ((DocLines.length > linesfullPage) &&
                        ((!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - Página 1/3")
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-3">
                      <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />

                      <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />
                        {/* <span className="text-center">{user.Timbra.RFC || ''}</span><br /> */}
                        <strong>{Datos_Empresa.RFC}</strong></p>

                      {/* <span className="text-left">Teléfono(s): {user.Branch.Phone || ''}</span> */}
                      <p style={{ fontSize: '10px' }}> <strong>Régimen Fiscal: </strong> 601 - General de Ley Personas Morales <br />{user.Branch.Address}.<br />
                        <span className="text-left">Teléfono(s): {user.Branch.Phone}</span></p>
                      {/* <p className="text-center"><br/>{user.Branch.Address || ''}</p> */}
                      <p className="text-center"></p>
                    </div>
                    <div className="col-9" style={{ fontSize: "13px" }}>
                      <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                          <tr>
                            <th className="text-center">Serie</th>
                            <th className="text-center">Folio</th>
                            <th className="text-center">Número de Certificado</th>
                            <th className="text-center">Fecha Emisión</th>
                            <th className="text-center">Lugar de Expedición</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center">{XML.isTimbra ? XML.info._attributes.Serie : ''}</td>
                            <td className="text-center">{!!DocHeader.DocNum && DocHeader.DocNum}</td>
                            <td className="text-center">{XML.isTimbra ? XML.info._attributes.NoCertificado : ''}</td>
                            <td className="text-center">{`${XML.isTimbra ? XML.info._attributes.Fecha : ''}`}</td>
                            <td className="text-center">{XML.isTimbra ? XML.info._attributes.LugarExpedicion : ''}</td>
                          </tr>
                        </tbody>
                      </table>
                      <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                          <tr>
                            <th className="text-center">Folio Fiscal</th>
                            <th className="text-center">Certificado SAT</th>
                            <th className="text-center">Fecha y Hora de Certificación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center" style={{ fontsize: "2.5vw" }}>{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.UUID : ''}</td>
                            <td className="text-center">{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.NoCertificadoSAT : ''}</td>
                            <td className="text-center">{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.FechaTimbrado : ''}</td>
                          </tr>
                        </tbody>
                      </table>
                      <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                          <tr>
                            <th className="text-center">Cliente</th>
                            <th className="text-center">Nombre del Cliente</th>
                            <th className="text-center">Régimen Fiscal</th>
                            <th className="text-center">Uso CFDI</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center">{DocHeader.CardCode || ""}</td>
                            <td className="text-center">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.Nombre : (DocHeader.CardName || "")}</td>
                            <td className="text-center">{DocHeader.U_FMB_REGIMEN_FISCAL ? `${DocHeader.U_FMB_REGIMEN_FISCAL} - ${this.getRegimenFiscal(DocHeader.U_FMB_REGIMEN_FISCAL)}` : ""}</td>
                            <td className="text-center">{XML.isTimbra ? `${XML.info.cfdiReceptor._attributes.UsoCFDI} - ${this.getUsoCFDI(XML.info.cfdiReceptor._attributes.UsoCFDI)}` : ""}</td>
                          </tr>
                        </tbody>
                      </table>
                      <table>
                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                          <tr>
                            <th className="text-center">Tipo Documento</th>
                            <th className="text-center">Condiciones de Pago</th>
                            <th className="text-center">R.F.C.</th>
                            <th className="text-center">Moneda</th>
                            <th className="text-center">Folio</th>
                            <th className="text-center">N° Referencia</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="text-center">{docType}</td>
                            <td className="text-center">{DocHeader.GroupName || ""}</td>
                            <td className="text-center">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.Rfc : !!DocHeader.LicTradNum && DocHeader.LicTradNum}</td>
                            <td className="text-center">{XML.isTimbra ? XML.info._attributes.Moneda : !!DocHeader.DocCur && DocHeader.DocCur}</td>
                            <td className="text-center">{InfoByFolio.folio || ''}</td>
                            <td className="text-center"><strong>{DocHeader.NumAtCard || ''}</strong></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className='row' style={{ paddingRight: "15px" }}>
                    <div className='col-4'>
                      <label className="text-center" style={{ fontSize: "14px" }}>{reprint ? <><strong>REIMPRESION: </strong>{user.U_NAME} {time}</> : ""}</label>
                    </div>
                    <div className='col-4'>
                      <div className="text-center" style={{ fontSize: "14px", fontWeight: "bold" }}>
                        {title + nota + (InfoByFolio && InfoByFolio.paidOut && InfoByFolio.paidOut == "Y" ? " (pagada)" : "")}
                        {(DocHeader.U_FMB_RelatedFolio && docType === 'Nota de Crédito') ? <> <br /> {`Basada en la factura${baseDocument}: ${DocHeader.U_FMB_RelatedFolio}`} </> : ''}
                      </div>
                    </div>
                    <table className="text-center">
                      <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <th>DOMICILIO DE FACTURACIÓN</th>
                        <th colSpan={2}>Forma y método de pago</th>
                      </tr>
                      <tr>
                        <td style={{ border: "solid 1px" }}>
                          {(XML.isTimbra && DocHeader.BillAddress) ? `${DocHeader.BillAddress.Street ? DocHeader.BillAddress.Street + ', ' : ''}${DocHeader.BillAddress.Block ? DocHeader.BillAddress.Block + ', ' : ''}${DocHeader.BillAddress.City ? DocHeader.BillAddress.City + ', ' : ''}${DocHeader.BillAddress.State ? DocHeader.BillAddress.State + ', ' : ''}${DocHeader.BillAddress.Country ? DocHeader.BillAddress.Country + ', ' : ''} C.P ${DocHeader.BillAddress.ZipCode ?? ''}`
                            : `${DocHeader.BillDirection || ""}`
                          }
                        </td>
                        <td style={{ border: "solid 1px" }}>{XML.isTimbra ? `${XML.info._attributes.FormaPago} - ${this.getFormaPago(XML.info._attributes.FormaPago)}` : `${DocHeader.U_FMB_FORMA_PAGO} - ${this.getFormaPago(DocHeader.U_FMB_FORMA_PAGO)}`}</td>
                        <td style={{ border: "solid 1px" }}>{XML.isTimbra ? `${XML.info._attributes.MetodoPago} - ${this.getMetodoPago(XML.info._attributes.MetodoPago)}` : `${DocHeader.U_FMB_METODO_PAGO} - ${this.getMetodoPago(DocHeader.U_FMB_METODO_PAGO)}`}</td>
                      </tr>
                      <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <th>DOMICILIO DE ENTREGA</th>
                        <th colSpan={2}>Fecha de vencimiento</th>
                      </tr>
                      <tr>
                        <td rowSpan={3} style={{ border: "solid 1px" }}>
                          {(XML.isTimbra && ShipAddress) ? `${ShipAddress.Street ? ShipAddress.Street + ', ' : ''}${ShipAddress.Block ? ShipAddress.Block + ', ' : ''}${ShipAddress.City ? ShipAddress.City + ', ' : ''}${ShipAddress.State ? ShipAddress.State + ', ' : ''}${ShipAddress.Country ? ShipAddress.Country + ', ' : ''} C.P ${ShipAddress.ZipCode ?? ''}`
                            : `${DocHeader.ShipDirection ?? 'NO APLICA'}`
                          }
                        </td>
                        <td colSpan={2} style={{ border: "solid 1px" }}>{!!DocHeader.DocDueDate && moment(DocHeader.DocDueDate).format("DD/MM/YYYY")}</td>
                      </tr>
                      <tr style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <th>Nombre del capturista</th>
                        <th>Asesor de ventas</th>
                      </tr>
                      <tr>
                        <td style={{ border: "solid 1px" }}>{DocHeader.U_FMB_User || ''}</td>
                        <td style={{ border: "solid 1px" }}>{DocHeader.SlpName || ''} </td>
                      </tr>
                    </table>
                    <table className='mt-2'>
                      <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                        <tr>
                          <th>Cant.</th>
                          <th>UMV</th>
                          <th>CVE</th>
                          <th>Cve P/S</th>
                          <th className="text-center">Código</th>
                          <th className="text-center">Descripción</th>
                          <th className="text-center">Tasa</th>
                          <th className="text-right">Precio U</th>
                          <th className="text-right">Importe</th>
                          {/* <th className="text-center">Descuento %</th> */}
                          <th className="text-right">Importe N.</th>
                        </tr>
                      </thead>
                      <tbody style={{ border: "solid 1px" }}>
                        {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                          DocLines.map((docLine) => {//51 es el limite de la primera pagina

                            if (countLines < 46) {
                              countLines++
                              return (
                                <>
                                  <tr style={{ fontSize: '12px' }}>
                                    <td>{Number(docLine.Quantity).toFixed(2) ?? ''}</td>
                                    <td>{getUnitMsr(docLine)}</td>
                                    <td>{docLine.U_FMB_UM_SAT ?? ''}</td>
                                    <td>{docLine.U_FMB_CLAVE_SAT ?? ''}</td>
                                    <td className="text-center">{docLine.ItemCode ?? ''}</td>
                                    <td className="text-center">{docLine.Dscription.substring(0, 35) ?? ''}</td>
                                    <td className="text-center">{Number(docLine.VatPrcnt).toFixed(0) ?? ''}</td>
                                    <td className="text-right">{formatNumber.new(docLine.Price) ?? ''}</td>
                                    <td className="text-right">{formatNumber.new(docLine.Quantity * docLine.Price) ?? ''}</td>
                                    {/* <td className="text-center">{Number(docLine.DiscPrcnt).toFixed(2) ?? 0}%</td> */}
                                    <td className="text-right">{formatNumber.new(docLine.LineTotal ?? 0)}</td>
                                  </tr>
                                  {docLine.U_FMB_LineComment != "" ?
                                    <tr style={{ fontSize: '12px' }}>
                                      <td ></td>
                                      <td colSpan={9}><strong>Comentario: </strong>{docLine.U_FMB_LineComment}</td>
                                    </tr>
                                    : ""
                                  }
                                </>
                              );
                            } else {
                              return ("");
                            }
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </td></tr></table>

            {/* Tablas extra de articulos */}
            {DocLines.length > linesfirstPage && extraTables}

            {/* Total */}
            <table><tr><td>
              <div style={(DocLines.length > (linesfirstPage - 5) && DocLines.length <= linesfirstPage) || (remainingLines === 0 && DocLines.length > 120) ?
                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }
                :
                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }
              }>
                {((DocLines.length > (linesfirstPage - 5) && DocLines.length <= linesfirstPage) || (remainingLines === 0 && DocLines.length > 120)) &&
                  <table className='mt-5' style={{ fontSize: "14px" }}>
                    <tbody>
                      <tr>
                        <td className='text-left'>
                          {InfoByFolio.folio}
                        </td>
                        <td className='text-right'>
                          {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina {totalPages + 2}/{totalPages + 2}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }
                <div className='row mt-2'>
                  <div className='col-8'>
                    <p style={DocHeader.isIns === 'Y' ? { marginLeft: "-13px", fontSize: '8px' } : (tckfolio || "") !== "" ? { marginLeft: "-13px", fontSize: '10px' } : { marginLeft: "-13px", fontSize: '12px' }}>
                      Comentarios: {DocHeader.Comments || ""}<br />
                      {(tckfolio || "") !== "" ? <div style={{ color: "red" }}>FACTURACION DE TICKET. MERCANCIA PREVIAMENTE ENTREGADA CON ESTE FOLIO: {tckfolio}</div> : ""}
                      {DocHeader.isIns === 'Y' ? <strong> ESTE MATERIAL DEBERA SER RETIRADO O RECIBIDO POR EL CLIENTE EN UN LAPSO MAXIMO DE 60 DIAS, DESPUES DE ESTE PERIODO SE LE APLICARA UN CARGO DE 10% MENSUAL POR ALMACENAMIENTO DE MATERIAL PENDIENTE DE ENTREGA.<br /></strong> : ""}
                      <span style={{ textDecoration: "underline" }}>TODA DEVOLUCIÓN CAUSARÁ UN CARGO DEL 10% DEL TOTAL DE LA FACTURA POR GASTOS ADMINISTRATIVOS.</span><br />
                      <span style={{ fontStyle: "italic" }}>NO ACEPTAMOS DEVOLUCIONES NI CANCELACIONES DESPUÉS DE 7 DÍAS, SIN EXCEPCIONES. EN MATERIALES ESPECIALES NO HAY DEVOLUCIONES.</span><br />
                      EFECTOS FISCALES AL PAGO. ESTA FACTURA SERÁ PAGADA EN UNA SOLA EXHIBICIÓN. <br />
                      Régimen fiscal del receptor: {this.taxSystem(!!DocHeader.U_FMB_REGIMEN_FISCAL ? DocHeader.U_FMB_REGIMEN_FISCAL : "")}.<br />
                      {totalLetra} {XML.isTimbra ? XML.info._attributes.Moneda : ''}
                    </p>
                  </div>
                  <div className='col-4'>
                    <table>
                      <tbody style={{ fontSize: '12px' }}>
                        <tr>
                          <td className='text-right'><strong>Subtotal: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderTop: "solid 1px", minWidth: "6.25vw" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum + advancePayment) ?? ''}</td>
                        </tr>
                        {/* <tr>
                          <td className='text-right'><strong>Descuento: %</strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{formatNumber.new(DocHeader.DiscPrcnt) ?? 0}</td>
                        </tr> */}
                        <tr>
                          <td className='text-right'><strong>IGV: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(DocHeader.VatSum) + (advancePayment * (Number(DocLines[0].VatPrcnt) / 100))) ?? ''}</td>
                        </tr>
                        {/* <tr>
                          <td className='text-right'><strong>Retención: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{''}</td>
                        </tr> */}
                        <tr>
                          <td className='text-right'><strong>Total: </strong></td>
                          <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderBottom: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(DocHeader.DocTotal) + advancePayment + (advancePayment * (Number(DocLines[0].VatPrcnt) / 100))) ?? ''}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {PuntosGenerados.length > 0 ?
                    <>
                      <div className='col-4'>
                      </div>
                      <div className='col-4 text-center'>
                        <p style={{ marginBottom: '0px' }}>
                          <><strong>¡</strong>Esta compra te ha generado <strong> {PuntosGenerados[0].points_earned} Puntos!</strong></>
                        </p>
                      </div>
                      <div className='col-4'>
                      </div>
                    </>
                    :
                    ''
                  }
                  {PointsCardModel && PointsCardModel.Customer && PointsCardModel.Customer.LostPoints && Object.keys(PointsCardModel.Customer.LostPoints).length !== 0 && (Object.keys(PointsCardModel.Customer.LostPoints).length !== 0 && PointsCardModel.Customer.LostPoints.puntos !== 0) ?
                    <>
                      <div className='col-4'>
                      </div>
                      <div className='col-4 text-center'>
                        <p style={{ marginBottom: '0px' }}>
                          <><strong>!Te perdiste de {PointsCardModel.Customer.LostPoints.puntos} Puntos!</strong></>
                        </p>
                      </div>
                      <div className='col-4'>
                      </div>

                      <div className='col-12 text-center'>
                        <p style={{ marginBottom: '0px' }}>
                          Este documento podría haberte sumado puntos en nuestro monedero electrónico. ¡Únete ahora y no dejes pasar más recompensas!
                        </p>
                      </div>
                    </>
                    :
                    ''
                  }
                </div>
              </div>
            </td></tr></table>

            {/* Sellos digitales */}
            <table><tr><td>
              <div style={(DocLines.length > 25 && DocLines.length < 40) || (remainingLines > 66 && remainingLines < linesfullPage) ?
                // <div style={(DocLines.length > 33 && DocLines.length < 48) || (DocLines.length > 105 && DocLines.length < 120)?
                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }
                :
                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }
              }>
                {((DocLines.length > 25 && DocLines.length < 40) || (remainingLines > 66 && remainingLines < linesfullPage)) &&
                  <table className='mt-5' style={{ fontSize: "14px" }}>
                    <tbody>
                      <tr>
                        <td className='text-left'>
                          {InfoByFolio.folio}
                        </td>
                        <td className='text-right'>
                          {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina {totalPages + 2}/{totalPages + 2}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }
                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                  <div className='col-12' style={{ border: "solid 1px" }}>
                    <table>
                      <thead>
                        <tr>
                          <th className="text-center"></th>
                          <th className="text-center">Este documento es una impresión de un comprobante fiscal digital</th>
                          <th className="text-center">Este documento es una representación impresa de un CFDI</th>
                          <th className="text-center"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-left" colSpan={3}>
                            <strong>Sello digital autorizado:</strong><br />
                            <p class='digitalStamp' style={{ marginBottom: "-5px" }}>{XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloCFD : ''}</p>
                          </td>
                          <td className="text-center" rowSpan={2}>
                            <QRCodeSVG
                              value={cadenaQR}
                              height={92}
                              width={92}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td className="text-left" colSpan={3}><strong>Sello digital SAT:</strong>
                            <p className='digitalStamp' style={{ marginBottom: "-5px" }}>
                              {XML.isTimbra ? XML.info.cfdiComplemento.tfdTimbreFiscalDigital._attributes.SelloSAT : ''}
                            </p>
                          </td>

                        </tr>
                        <tr>
                          <td className="text-left" colSpan={4}>
                            <strong>Cadena original:</strong>
                            <p className='digitalStampAlt' style={{ marginBottom: "5px" }}>{cfdiCaComplemento}</p>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </td></tr></table>

            {/* Pagare */}
            <table><tr><td>
              <div style={(DocLines.length > 9 && DocLines.length < 25) || (remainingLines > 53 && remainingLines < 68) ?
                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw" }
                :
                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }
              }>
                {((DocLines.length > 9 && DocLines.length < 25) || (remainingLines > 53 && remainingLines < 68)) &&
                  <table className='mt-5' style={{ fontSize: "14px" }}>
                    <tbody>
                      <tr>
                        <td className='text-left'>
                          {InfoByFolio.folio}
                        </td>
                        <td className='text-right'>
                          {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina {totalPages + 2}/{totalPages + 2}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }
                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                  <div className='col-12' style={{ border: "solid 1px" }}>
                    <p style={{ fontSize: '11px' }}>
                      {`Pagaré No.1 En ${DocHeader.U_FMB_LUGAREXPEDICION || ''}, a ${timbraDate}. Bueno por ${CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal) ?? ''}`} <br />
                      {`Debo(emos) y pagaré(mos) incondicionalmente por este pagaré a la orden de ${Datos_Empresa.Nombre} ${Datos_Empresa.Sociedad},`}<br />
                      {`Fecha pago: ${`${!!DocHeader.DocDate && moment(DocHeader.DocDate).format("DD/MM/YYYY")}`}.`}<br />
                    </p>
                    <p style={{ fontSize: '11px' }}>
                      {`La cantidad de: ${totalLetra} ${XML.isTimbra ? XML.info._attributes.Moneda : ''}
                      Valor recibido a mi(nuestra) entera satisfacción, este pagaré sujeto a la condición de que al no pagarse a su vencimiento será exigible, desde la fecha de su vencimiento de este
                      documento hasta el día de su liquidación, causará intereses moratorios al tipo de 3% mensual, pagadero en esta ciudad justamente con el principal.`}
                    </p>
                    <table>
                      <thead>
                        <tr>
                          <th className="text-center"></th>
                          <th className="text-left"><strong>Nombre y datos del deudor</strong></th>
                          <th className="text-center">Aceptamos</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="text-right">Nombre:</td>
                          <td className="text-left">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.Nombre : !!DocHeader.CardName && DocHeader.CardName}</td>
                          <td className="text-center"></td>
                        </tr>
                        <tr>
                          <td className="text-right">RUT:</td>
                          <td className="text-left">{XML.isTimbra ? XML.info.cfdiReceptor._attributes.Rfc : !!DocHeader.LicTradNum && DocHeader.LicTradNum}</td>
                          <td className="text-center">______________________________</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td className="text-left"></td>
                          <td className="text-center">Firma</td>
                        </tr>
                      </tbody>
                    </table>
                    <table>
                      <tbody>
                        <tr>
                          <td className="text-center">Dirección:
                            {(XML.isTimbra && DocHeader.BillAddress) ?
                              (`${DocHeader.BillAddress.Street ? DocHeader.BillAddress.Street + ', ' : ''}${DocHeader.BillAddress.Block ? DocHeader.BillAddress.Block + ', ' : ''}${DocHeader.BillAddress.City ? DocHeader.BillAddress.City + ', ' : ''}${DocHeader.BillAddress.State ? DocHeader.BillAddress.State + ', ' : ''}${DocHeader.BillAddress.Country ? DocHeader.BillAddress.Country + ', ' : ''} C.P ${DocHeader.BillAddress.ZipCode ?? ''}`)
                              :
                              (`${DocHeader.BillDirection}`)
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </td></tr></table>

            {/* Referencias para depositos */}
            <table ><tr><td>
              <div style={(DocLines.length > 5 && DocLines.length < 9) || (remainingLines > 40 && remainingLines < 52) ?
                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "7vw", marginBottom: "600px" }
                :
                { height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto" }
              }>
                {((DocLines.length > 5 && DocLines.length < 9) || (remainingLines > 40 && remainingLines < 52)) &&
                  <table className='mt-5' style={{ fontSize: "14px" }}>
                    <tbody>
                      <tr>
                        <td className='text-left'>
                          {InfoByFolio.folio}
                        </td>
                        <td className='text-right'>
                          {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina {totalPages + 2}/{totalPages + 2}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }
                <div className='row mt-5' style={{ paddingRight: "15px" }}>
                  <div className='col-2' style={{ border: "solid 1px" }}>
                    <p className='text-center m-4' style={{ margin: "auto" }}>
                      <strong>REFERENCIAS<br />PARA<br />DEPÓSITO<br />BANCARIO</strong>
                    </p>
                  </div>
                  <div className='col-10 p-2' style={{ border: "solid 1px" }}>
                    <table>
                      <tbody>
                        <tr>
                          <td>Para transferencias:</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Para transferencias:</td>
                          <td>Cuenta: 00000515541</td>
                          <td>CLABE: 113180000005155411</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Para depósitos en ventanilla:</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Banco: Santander</td>
                          <td>Cuenta: 65506444181</td>
                          <td>CLABE: 014730655064441811</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Banco: HSBC</td>
                          <td>Cuenta: 4062752217</td>
                          <td>CLABE: 021730040627522173</td>
                          <td>Referencia:</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </td></tr></table>
          </>
        }
      </>
    )
  }
}

export default InvoiceDoc